import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Button,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../services/api'

async function desligarVendedor(codigoVendedor) {
  const response = await api.get(
    `/site/v2/crm-controle/desliga-vendedor-sistema/${codigoVendedor}`,
  )

  return response.data
}

export function DesligarVendedor({ codigoVendedor, nomeVendedor }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: desligarVendedor,
    onError: (error, variables, context) => {
      console.log(error)
    },
    onSuccess: (data, variables, context) => {
      console.log(data)
      queryClient.invalidateQueries('controle-rodizio')
      onClose()
    },
  })

  async function handleDesligarVendedor() {
    try {
      await mutateAsync(codigoVendedor)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Button colorScheme="red" onClick={onOpen} size="sm">
        Desligar Vendedor
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        size="xl"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Desligar Vendedor -{' '}
              <Text textTransform="capitalize" as="span">
                {nomeVendedor}
              </Text>
            </AlertDialogHeader>
            <AlertDialogBody>
              Você tem certeza que deseja desligar o vendedor?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={handleDesligarVendedor} ml={3}>
                Desligar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
